import { Box, Button, styled, Typography } from "@mui/material"
import { colors } from "../../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 20,
  gap: 8,
})

export const TitleContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  backgroundColor: `${colors.lightGrey}`,
  padding: "16px",
  borderRadius: 4,
  marginTop: 2,
  marginBottom: 2,
  boxSizing: "border-box",
}

export const Amount = styled(Typography)({
  marginTop: 10,
  color: colors.lightBlack,
  fontSize: 42,
  lineHeight: "48px",
  alignSelf: "flex-start",
})

type MerchantBrandNameVariant = "plain" | "badge"

export const MerchantBrandName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "brandVariant",
})<{ brandVariant?: MerchantBrandNameVariant }>(
  ({ brandVariant = "plain" }) => ({
    alignSelf: "flex-start",
    marginTop: 0,
    marginBottom: 12,
    width: "100%",
    boxSizing: "border-box",
    ...(brandVariant === "badge"
      ? {
          color: colors.white,
          backgroundColor: colors.lightBlack,
          fontSize: 18,
          fontWeight: 500,
          lineHeight: "18px",
          padding: "18px",
          borderRadius: "16px",
          textTransform: "uppercase",
        }
      : {
          color: colors.lightBlack,
          fontSize: 22,
          fontWeight: 500,
          lineHeight: "28px",
        }),
  }),
)

export const DetailLabel = styled(Typography)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
  alignSelf: "flex-start",
})

export const DetailValue = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 20,
  lineHeight: "24px",
  marginTop: 4,
  wordBreak: "break-all",
  alignSelf: "flex-start",
})

export const ContinueButton = styled(Button)({
  minHeight: 54,
  width: "100%",
})

export const BottomContainer = styled(Box)({
  marginTop: "auto",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
})

